import iconThemeColor from "../index";

const UpAndDownArrows = ({ fillColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355C4.84171 7.54882 5.15829 7.54882 5.35355 7.35355L7.5 5.20711V20C7.5 20.2761 7.72386 20.5 8 20.5C8.27614 20.5 8.5 20.2761 8.5 20V5.20711L10.6464 7.35355C10.8417 7.54882 11.1583 7.54882 11.3536 7.35355C11.5488 7.15829 11.5488 6.84171 11.3536 6.64645L8.35355 3.64645C8.15829 3.45119 7.84171 3.45119 7.64645 3.64645L4.64645 6.64645Z"
        fill={fillColor}
      />
      <path
        d="M12.6464 17.3536C12.4512 17.1583 12.4512 16.8417 12.6464 16.6464C12.8417 16.4512 13.1583 16.4512 13.3536 16.6464L15.5 18.7929V4C15.5 3.72386 15.7239 3.5 16 3.5C16.2761 3.5 16.5 3.72386 16.5 4V18.7929L18.6464 16.6464C18.8417 16.4512 19.1583 16.4512 19.3536 16.6464C19.5488 16.8417 19.5488 17.1583 19.3536 17.3536L16.3536 20.3536C16.1583 20.5488 15.8417 20.5488 15.6464 20.3536L12.6464 17.3536Z"
        fill={fillColor}
      />
    </svg>
  );
};

const ExpandIcon = ({ fillColor, width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 5C13.5 5.27614 13.7239 5.5 14 5.5H17.7929L13.6464 9.64645C13.4512 9.84171 13.4512 10.1583 13.6464 10.3536C13.8417 10.5488 14.1583 10.5488 14.3536 10.3536L18.5 6.20712L18.4999 9.99999C18.4999 10.2761 18.7238 10.5 18.9999 10.5C19.2761 10.5 19.4999 10.2761 19.4999 10L19.5 5.00001C19.5 4.8674 19.4473 4.74022 19.3536 4.64645C19.2598 4.55268 19.1326 4.5 19 4.5H14C13.7239 4.5 13.5 4.72386 13.5 5Z"
        fill={fillColor}
      />
      <path
        d="M10.5 19C10.5 18.7239 10.2761 18.5 10 18.5H6.20711L10.3536 14.3536C10.5488 14.1583 10.5488 13.8417 10.3536 13.6464C10.1583 13.4512 9.84171 13.4512 9.64645 13.6464L5.50001 17.7929L5.50005 14C5.50006 13.7239 5.2762 13.5 5.00006 13.5C4.72392 13.5 4.50006 13.7239 4.50005 14L4.5 19C4.5 19.1326 4.55268 19.2598 4.64644 19.3536C4.74021 19.4473 4.86739 19.5 5 19.5H10C10.2761 19.5 10.5 19.2761 10.5 19Z"
        fill={fillColor}
      />
    </svg>
  );
};

const CompressIcon = ({ fillColor, width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 11H18.5C18.7761 11 19 10.7761 19 10.5C19 10.2239 18.7761 10 18.5 10H14.7071L18.8536 5.85355C19.0488 5.65829 19.0488 5.34171 18.8536 5.14645C18.6583 4.95118 18.3417 4.95118 18.1464 5.14645L14 9.29288L14.0001 5.50001C14.0001 5.22386 13.7762 5 13.5001 5C13.2239 5 13.0001 5.22385 13.0001 5.49999L13 10.5C13 10.6326 13.0527 10.7598 13.1464 10.8536C13.2402 10.9473 13.3674 11 13.5 11Z"
        fill={fillColor}
      />
      <path
        d="M5 13.5C5 13.7761 5.22386 14 5.5 14H9.29289L5.14645 18.1464C4.95118 18.3417 4.95118 18.6583 5.14645 18.8536C5.34171 19.0488 5.65829 19.0488 5.85355 18.8536L9.99999 14.7071L9.99995 18.5C9.99994 18.7761 10.2238 19 10.4999 19C10.7761 19 10.9999 18.7761 10.9999 18.5L11 13.5C11 13.3674 10.9473 13.2402 10.8536 13.1464C10.7598 13.0527 10.6326 13 10.5 13H5.5C5.22386 13 5 13.2239 5 13.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AngleLeft = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3763 4.67075C16.1944 4.46294 15.8786 4.44188 15.6707 4.62372L7.67074 11.6237C7.56223 11.7187 7.49999 11.8558 7.49999 12C7.49999 12.1442 7.56223 12.2814 7.67074 12.3763L15.6707 19.3763C15.8786 19.5581 16.1944 19.5371 16.3763 19.3293C16.5581 19.1214 16.5371 18.8056 16.3292 18.6237L8.75929 12L16.3292 5.3763C16.5371 5.19445 16.5581 4.87857 16.3763 4.67075Z"
        fill={fillColor}
      />
    </svg>
  );
};

const AngleRight = ({ fillColor, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.62372 4.67075C7.80556 4.46294 8.12144 4.44188 8.32926 4.62372L16.3293 11.6237C16.4378 11.7187 16.5 11.8558 16.5 12C16.5 12.1442 16.4378 12.2814 16.3293 12.3763L8.32926 19.3763C8.12144 19.5581 7.80556 19.5371 7.62372 19.3293C7.44188 19.1214 7.46294 18.8056 7.67075 18.6237L15.2407 12L7.67075 5.3763C7.46294 5.19445 7.44188 4.87857 7.62372 4.67075Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ThemedUpAndDownArrows = iconThemeColor(UpAndDownArrows);
export const ThemedExpandIcon = iconThemeColor(ExpandIcon);
export const ThemedCompressIcon = iconThemeColor(CompressIcon);
export const ThemedAngleLeft = iconThemeColor(AngleLeft);
export const ThemedAngleRight = iconThemeColor(AngleRight);
